import { createContext } from "react";

// Optional owner of forms that need to guard navigation away from unsaved edits.
export const FormDirtyContext = createContext<((formId: string, dirty: boolean) => void) | null>(null);
